export default "__VITE_ASSET__CCYVLSRT__"